import { useCallback, useEffect, useRef, useState } from "react";
import { Draggable } from "react-drag-reorder";
import { connect } from "react-redux";
import {
  getWidgets,
  updateWidgetPriority,
} from "../../../../action/masters/widgetActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
  sortAlphabetically,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { IWidgetsPriority } from "../../../../models/master/widgets";
import {
  IDragable,
  IDragableItem,
} from "../../../../models/settings/studentSettings";
import LoaderSpinner from "../../../loader";
import { masterType } from "../../../../constants/masterTypes";
import FloatingLabelDropDown from "../../../floatingdropdown";
import {
  getUserPageBlocks,
  getUserWidgetPageBlocks,
} from "../../../../action/common/commonActionCreator";

const WidgetPriority = (props: IDragable) => {
  const {
    items,
    updateWidgetPriority,
    getAllWidgets,
    getUserPageBlocks,
    pageBlocks,
    currentCollege,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [selectedCollege] = useState<any>(currentCollege);
  const [selectedPageBlock, setSelectedPageBlock] = useState<any>(null);
  const isInitialMount = useRef(true);

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateWidgetPriority && updateWidgetPriority(_items, callBack);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    setLoader(true);
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);

    setfilteredItems([..._items]);
    updateWidgetPriority && updateWidgetPriority(_items, callBack);
  };

  const callBack = useCallback(
    async (e: any) => {
      if (getAllWidgets) {
        await getAllWidgets(selectedPageBlock, selectedCollege);
        setLoader(false);
      }
    },
    [getAllWidgets, selectedPageBlock, selectedCollege]
  );

  useEffect(() => {
    if (items) {
      let _items = cloneDeep(items);
      let _visible = _items.filter((x: any) => x.displayOrNot);
      let _hidden = _items.filter((x: any) => !x.displayOrNot);
      let _finalItems = [..._visible, ..._hidden];
      _finalItems = prioratiseItems(_finalItems);
      setfilteredItems(_finalItems);
    }
  }, [items]);

  useEffect(() => {
    if (pageBlocks && pageBlocks?.length > 0 && !selectedPageBlock) {
      const defaultPageBlock = pageBlocks[0];
      setSelectedPageBlock(defaultPageBlock.id);
    }
  }, [pageBlocks]);

  useEffect(() => {
    if (selectedCollege && selectedPageBlock) {
      if (!isInitialMount.current) {
        setLoader(true);
      } else {
        isInitialMount.current = false;
      }
      callBack(true);
    }
  }, [selectedPageBlock]);

  const onSelectionChange = useCallback((e: any) => {
    setSelectedPageBlock(e.target.value);
  }, []);

  useEffect(() => {
    getUserPageBlocks && getUserPageBlocks(masterType.widget);
  }, []);

  return (
    <>
      <div className="col-md-7 justify-content-left mt-3 dropsetting-label">
        <FloatingLabelDropDown
          label="Page-Block"
          placeholder=""
          onChange={onSelectionChange}
          isMandatory={false}
          value={selectedPageBlock}
          name="pageBlock"
          optionsList={sortAlphabetically(pageBlocks)}
          showClear={false}
        />
      </div>
      <ul id="widget-sortable" className="sortable-card mt-28">
        {loader ? (
          <LoaderSpinner />
        ) : filteredItems?.length > 0 ? (
          <>
            <Draggable
              onPosChange={async (currentPos, newPos) => {
                await saveChangedPos(currentPos, newPos);
              }}
            >
              {filteredItems
                .filter((item: IWidgetsPriority) => item?.displayOrNot)
                .map((item: IWidgetsPriority) => {
                  return (
                    <li className="setting-default">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{item?.displayPriority}</span>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img src={baseURL + item?.image} alt="" />
                        </div>
                        <h2>{item?.name}</h2>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={item?.displayOrNot}
                            id={item?.priority + "widget"}
                            onChange={() => {
                              ChangeVisibleOrNot(
                                item?.id ?? 0,
                                !item?.displayOrNot
                              );
                            }}
                          />
                          <label htmlFor={item?.priority + "widget"}></label>
                        </div>
                      </div>
                    </li>
                  );
                })}
            </Draggable>
            {filteredItems
              .filter((item: IWidgetsPriority) => !item?.displayOrNot)
              .map((item: IWidgetsPriority) => (
                <li className="setting-default">
                  <div className="top">
                    <span className="handle">
                      <img src="/assets/images/drag.svg" />
                    </span>
                    <span className="counter">{item?.displayPriority}</span>
                  </div>
                  <div className="btm">
                    <div className="img">
                      <img src={baseURL + item?.image} alt="" />
                    </div>
                    <h2>{item?.name}</h2>
                    <div className="form-checkbox">
                      <input
                        type="checkbox"
                        checked={item?.displayOrNot}
                        id={item?.priority + "widget"}
                        onChange={() => {
                          ChangeVisibleOrNot(item?.id ?? 0, !item?.displayOrNot);
                        }}
                      />
                      <label htmlFor={item?.priority + "widget"}></label>
                    </div>
                  </div>
                </li>
              ))}
          </>
        ) : (
          <p>No Records Found</p>
        )}
      </ul>
    </>
  );
};

const mapDispatchToProps = {
  updateWidgetPriority: (items: IDragableItem[], callBack: Function) =>
    updateWidgetPriority(items, callBack),
  getAllWidgets: (pageBlockId: number, collegeId?: number) =>
    getWidgets(undefined, pageBlockId, collegeId),
  getUserPageBlocks: (masterType: string) =>
    getUserWidgetPageBlocks(undefined, masterType),
};

function mapStateToProps(state: any) {
  return {
    items: state.widget.widgets,
    pageBlocks: state.common.widgetPageBlocks,
    currentCollege: state.userDetails.userProfileData?.currentCollege?.id,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetPriority);
